import { MouseEventHandler } from 'react';

export const blockIfSelecting =
  (cb?: MouseEventHandler): MouseEventHandler =>
  (e) => {
    const selection = window.getSelection();

    if (selection && window.getSelection()?.type === 'Range' && (<Node>e.target).contains(selection.anchorNode)) {
      e.stopPropagation();

      return false;
    }

    cb?.(e);
  };
